import { Stack } from 'expo-router';

import { ErrorPage } from '@/components/error-page';

export default function NotFound() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <ErrorPage status={404} />
    </>
  );
}
